import { objectSelector } from 'theme/utils';

const $P = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/packageOrderList`);

class PackageOrderList {
  constructor(data) {
    const { results, count } = data;
    this.results = results;
    this.count = count;
  }
}

class PackageOrder {
  constructor(packageOrder) {
    const {
      id,
      channelName,
      datePlaced,
      number,
      orderNumber,
      packageItemSet,
      state,
      stockLocation,
      targetPackingDate,
      shippingAddress,
      deliveryRange,
      orderHasGiftBox,
    } = packageOrder;
    this.id = id;
    this.channelName = channelName;
    this.datePlaced = datePlaced;
    this.number = number;
    this.orderNumber = orderNumber;
    this.orderHasGiftBox = orderHasGiftBox;
    this.packageItemSet = packageItemSet;
    this.state = state;
    this.stockLocation = stockLocation;
    this.targetPackingDate = targetPackingDate;
    this.shippingAddress = shippingAddress;
    this.deliveryRange = deliveryRange;
  }
}

class ShippingAddress {
  constructor(item) {
    const {
      customerName,
      customerSurname,
      customerEmail,
      phone,
      title,
      district,
      township,
      line,
      city,
    } = item;
    this.customerName = customerName;
    this.customerSurname = customerSurname;
    this.customerEmail = customerEmail;
    this.phone = phone;
    this.title = title;
    this.district = district;
    this.township = township;
    this.line = line;
    this.city = city;
  }
}

const shippingAddressMapper = (item) => {
  const { SHIPPING_ADDRESS } = $P.PACKAGE_ORDER;

  return new ShippingAddress({
    customerName: objectSelector(item, SHIPPING_ADDRESS.CUSTOMER_NAME),
    customerSurname: objectSelector(item, SHIPPING_ADDRESS.CUSTOMER_SURNAME),
    customerEmail: objectSelector(item, SHIPPING_ADDRESS.CUSTOMER_EMAIL),
    phone: objectSelector(item, SHIPPING_ADDRESS.PHONE),
    title: objectSelector(item, SHIPPING_ADDRESS.TITLE),
    district: objectSelector(item, SHIPPING_ADDRESS.DISTRICT),
    township: objectSelector(item, SHIPPING_ADDRESS.TOWNSHIP),
    line: objectSelector(item, SHIPPING_ADDRESS.LINE),
    city: objectSelector(item, SHIPPING_ADDRESS.CITY),
  });
};

const packageOrderMapper = (packageOrders) => {
  return packageOrders.map((item) => {
    return new PackageOrder({
      id: objectSelector(item, $P.PACKAGE_ORDER.ID),
      channelName: objectSelector(item, $P.PACKAGE_ORDER.CHANNEL_NAME),
      datePlaced: objectSelector(item, $P.PACKAGE_ORDER.DATE_PLACED),
      number: objectSelector(item, $P.PACKAGE_ORDER.NUMBER),
      orderHasGiftBox: objectSelector(item, $P.ORDER_HAS_GIFT_BOX),
      orderNumber: objectSelector(item, $P.PACKAGE_ORDER.ORDER_NUMBER),
      packageItemSet: objectSelector(item, $P.PACKAGE_ORDER.PACKAGE_ITEM_SET),
      state: objectSelector(item, $P.PACKAGE_ORDER.STATE),
      stockLocation: objectSelector(item, $P.PACKAGE_ORDER.STOCK_LOCATION),
      targetPackingDate: objectSelector(
        item,
        $P.PACKAGE_ORDER.TARGET_PACKING_DATE
      ),
      shippingAddress: shippingAddressMapper(
        objectSelector(item, $P.PACKAGE_ORDER.SHIPPING_ADDRESS_PATH)
      ),
      deliveryRange: objectSelector(item, $P.PACKAGE_ORDER.DELIVERY_RANGE),
    });
  });
};

export const packageOrderListMapper = (data) => {
  return new PackageOrderList({
    results: packageOrderMapper(objectSelector(data, $P.PACKAGE_ORDERS, [])),
    count: objectSelector(data, $P.PACKAGE_COUNT),
  });
};



// WEBPACK FOOTER //
// ./src/models/packageOrderList.js